export function formatNumber(value: number | string, maximumFractionDigits = 2, isCents = false) {
  let parsedValue = Number(value);
  if (isCents) parsedValue /= 100;

  return new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits,
    minimumFractionDigits: 2,
  }).format(parsedValue);
}
